import type { CatalogEntry } from './types.js';

/**
 * Paletas de marca compartidas por los efectos.
 *
 * `BRAND` espeja los tokens del shell (`--lime`, `--purple`, blanco, cyan,
 * coral); `WARM` es la variante cálida para rachas/fuego. Se mantienen como
 * literales (no leídos de CSS) porque los efectos de canvas pintan colores
 * concretos por partícula — resolver `getComputedStyle` por frame sería caro.
 * Si cambian los tokens, actualizá `BRAND[0]`/`BRAND[1]` acá.
 */
export const BRAND = ['#d4f23e', '#a78bfa', '#ffffff', '#5ce1e6', '#ff9d6c'] as const;
export const WARM = ['#ffd166', '#ff9d6c', '#ff6b4a', '#ffe9a8', '#ffb15c'] as const;
/**
 * Dorado del festejo bonus: sale de `WARM` (sin el rojo `#ff6b4a`) más un oro
 * medio y blanco. El oro se repite a propósito para que pese más que el coral:
 * es una lluvia dorada con algo de coral, no al revés. Nada de amarillo neón.
 */
export const GOLD = [
  '#ffd166',
  '#f4b740',
  '#ffe9a8',
  '#ffd166',
  '#ff9d6c',
  '#ffffff',
  '#e8a13c',
] as const;

/** Catálogo de efectos + cuándo conviene usar cada uno (guía de producto). */
export const CELEBRATION_CATALOG: readonly CatalogEntry[] = [
  {
    id: 'confetti-cannons',
    name: 'Confeti · Cañones',
    group: 'Confeti',
    when: 'Logro grande: completar todas las misiones de un escenario o terminar un nivel.',
  },
  {
    id: 'confetti-rain',
    name: 'Confeti · Lluvia',
    group: 'Confeti',
    when: 'Festejo más suave: cerrar una sesión, sumar minutos del día.',
  },
  {
    id: 'fireworks',
    name: 'Fuegos artificiales',
    group: 'Hitos',
    when: 'Hito mayor: subir de nivel CEFR, una racha récord.',
  },
  {
    id: 'level-up',
    name: 'Subida de nivel',
    group: 'Hitos',
    when: 'Cuando el alumno asciende de nivel o intensidad.',
  },
  {
    id: 'sparkles',
    name: 'Destellos',
    group: 'Microfeedback',
    when: 'Microelogio: buena pronunciación, una frase que sonó nativa.',
  },
  {
    id: 'success-pulse',
    name: 'Pulso de acierto',
    group: 'Microfeedback',
    when: 'Confirmación rápida: objetivo cumplido, ejercicio correcto.',
  },
  {
    id: 'streak',
    name: 'Racha de fuego',
    group: 'Constancia',
    when: 'Al mantener o extender la racha diaria.',
  },
  {
    id: 'emoji-float',
    name: 'Emojis al vuelo',
    group: 'En vivo',
    when: 'Ánimo durante la charla o reacciones en vivo.',
  },
  {
    id: 'bonus-rain',
    name: 'Bonus · Lluvia dorada',
    group: 'Bonus',
    when: 'Objetivo bonus cumplido: confeti dorado mucho más denso que los cañones, con un par de cañones extra.',
  },
  {
    id: 'achievement',
    name: 'Insignia de logro',
    group: 'En vivo',
    when: 'Desbloquear una medalla o insignia, con título y subtítulo.',
  },
];
